<template>
  <router-view />
</template>

<style lang="scss">
@font-face {
  font-family: "Neue Plak";
  src: url("@/assets/fonts/NeuePlak-CompLight.woff2") format("woff2"),
    url("@/assets/fonts/NeuePlak-CompLight.woff") format("woff");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Neue Plak";
  src: url("@/assets/fonts/NeuePlak-NarrowRegular.woff2") format("woff2"),
    url("@/assets/fonts/NeuePlak-NarrowRegular.woff") format("woff");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Neue Plak";
  src: url("@/assets/fonts/NeuePlak-NarrowRegular.woff2") format("woff2"),
    url("@/assets/fonts/NeuePlak-NarrowRegular.woff") format("woff");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Neue Plak";
  src: url("@/assets/fonts/NeuePlak-Black.woff2") format("woff2"),
    url("@/assets/fonts/NeuePlak-Black.woff") format("woff");
  font-weight: 800;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Neue Plak";
  src: url("@/assets/fonts/NeuePlak-CondExtraBlack.woff2") format("woff2"),
    url("@/assets/fonts/NeuePlak-Regular.woff") format("woff");
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}

#app {
  font-family: "Neue Plak", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--blue);
}
html,
body {
  padding: 0;
  margin: 0;
  scroll-behavior: smooth;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: var(--darker-blue);
  }
  &::-webkit-scrollbar-thumb {
    background-color: var(--blue);
  }
}
:root {
  --dark-blue: #00215b;
  --darker-blue: #001334;
  --blue: #4b92db;
  --black: #000;
  --white: #fff;
  --red: #c60c03;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
